/**
 * After a deploy, a tab opened on the previous version asks for page files that no longer exist
 * ("Failed to fetch dynamically imported module"). Reloading picks up the new version.
 * A short guard stops a reload loop if the file is missing for another reason.
 */
const KEY = 'crm.staleBuildReloadAt';
const GUARD_MS = 30_000;

export function isChunkLoadError(error: unknown): boolean {
  const msg = error instanceof Error ? error.message : typeof error === 'string' ? error : '';
  return /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS/i.test(msg);
}

/** Reloads once (per 30s) and returns true; returns false when a reload just happened and it still fails. */
export function reloadForNewVersion(now = Date.now()): boolean {
  let last = 0;
  try {
    last = Number(sessionStorage.getItem(KEY) ?? 0);
  } catch {
    /* storage unavailable */
  }
  if (now - last < GUARD_MS) return false;
  try {
    sessionStorage.setItem(KEY, String(now));
  } catch {
    /* storage unavailable */
  }
  window.location.reload();
  return true;
}
